/* Adds Dog Portrait attributes to Storefront Cart GraphQL calls (cartCreate/cartLinesAdd) */
(function(){
  const KEYS = ['Dog name','Dog original URL','Dog stage1 URL','Dog portrait URL','Portrait URL'];

  function collectProps(){
    // Prefer global props, fall back to hidden inputs
    const out = Object.assign({}, window.__DPC_PROPS || {});
    KEYS.forEach(k => {
      if (!(k in out)) {
        const el = document.querySelector(`input[data-dpc-prop="${k}"]`);
        if (el && el.value) out[k] = el.value;
      }
    });
    return Object.keys(out).length ? out : null;
  }

  function toAttributes(props){
    return Object.entries(props).map(([key,value]) => ({ key, value: String(value) }));
  }
  function mergeAttributes(existingArr, addArr){
    const map = new Map();
    (existingArr || []).forEach(({key,value}) => map.set(String(key), String(value)));
    (addArr || []).forEach(({key,value}) => map.set(String(key), String(value)));
    return Array.from(map.entries()).map(([key,value]) => ({ key, value }));
  }
  function isStorefrontGraphQL(urlLike){
    try {
      const u = new URL(typeof urlLike === 'string' ? urlLike : (urlLike && urlLike.url) || '', location.origin);
      return /^\/api\/\d{4}-\d{2}\/graphql\.json$/i.test(u.pathname);
    } catch { return false; }
  }
  function augmentGraphQLBody(bodyStr, props){
    let payload; try { payload = JSON.parse(bodyStr); } catch { return bodyStr; }
    const attrs = toAttributes(props);

    function patchOne(obj){
      if (!obj || typeof obj !== 'object') return obj;
      const v = obj.variables || obj;

      if (v && Array.isArray(v.lines)) {
        v.lines = v.lines.map(line => (line && typeof line === 'object')
          ? Object.assign(line, { attributes: mergeAttributes(line.attributes, attrs) })
          : line
        );
      }
      if (v && v.input && Array.isArray(v.input.lines)) {
        v.input.lines = v.input.lines.map(line => (line && typeof line === 'object')
          ? Object.assign(line, { attributes: mergeAttributes(line.attributes, attrs) })
          : line
        );
      }
      return obj;
    }

    if (Array.isArray(payload)) return JSON.stringify(payload.map(patchOne));
    return JSON.stringify(patchOne(payload));
  }

  // fetch patch
  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = async function(input, init){
      try {
        const url = typeof input === 'string' ? input : (input && input.url);
        if (!isStorefrontGraphQL(url) || !init || typeof init.body !== 'string') {
          return origFetch.apply(this, arguments);
        }
        const props = collectProps(); if (!props) return origFetch.apply(this, arguments);
        init.body = augmentGraphQLBody(init.body, props);
        return origFetch.call(this, input, init);
      } catch {
        return origFetch.apply(this, arguments);
      }
    };
  }

  // XHR patch (for libs that still use XHR)
  const X = window.XMLHttpRequest;
  if (X) {
    const open = X.prototype.open, send = X.prototype.send;
    let lastUrl = '';
    X.prototype.open = function(method, url){ lastUrl = url; return open.apply(this, arguments); };
    X.prototype.send = function(body){
      try {
        if (isStorefrontGraphQL(lastUrl) && typeof body === 'string') {
          const props = collectProps(); if (props) body = augmentGraphQLBody(body, props);
        }
      } catch {}
      return send.call(this, body);
    };
  }
})();
